export const tabs = [
  { title: "School Info.", value: "1" },
  { title: "Installment Schedule", value: "2" },
  { title: "CRM", value: "3" },
  { title: "Inventory", value: "4" },
  { title: "Lab", value: "5" },
];
